// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"we_a bht_b bht_we"};